import { cva } from 'class-variance-authority';

export const bodyVariants = cva(
  [
    'overflow-y-auto',
    'text-color-ref-text-strong',
    'text-font-ref-body-medium-font-size',
    'font-ref-body-medium-font-weight',
    'font-ref-body-medium-font-family',
    'tracking-font-ref-body-medium-letter-spacing',
    'p-spacing-sys-spacing-16',
  ],
  {
    variants: {
      // `flex-initial` (`flex: 0 1 auto`), not `flex-1`: the animated body carries
      // an explicit height, and `flex-1`'s zero basis would ignore it. Shrink stays
      // on so the dialog's `max-h-[85vh]` still wins and the body scrolls instead.
      animateHeight: {
        true: 'flex-initial transition-height motion-reduce:transition-none duration-200 ease-out',
        false: 'flex-1',
      },
    },
    defaultVariants: {
      animateHeight: false,
    },
  },
);
